import {combineEpics} from 'redux-observable';
import {bidsEpic} from "./bids";
import {projectsEpic} from "./projects";
import {usersEpic} from './users';
import {companiesEpic} from "./companies";
import {codesEpic} from "./codes";
import {rfisEpic} from "./rfis";
import {submittalsEpic} from "./submittals";
import {tasksEpic} from "./tasks";
import {dailyLogsEpic} from "./dailyLogs";
import {punchListEpic} from "./punchList";
import {bidContactsEpic} from "./bidcontacts";
import {projectContactsEpic} from "./projectcontacts";
import {filesEpic} from "./files";
import {reportsEpic} from "./reports";
import {catchError} from "rxjs/operators";
import {concat, interval, of} from "rxjs";
import {networkError} from "../actions/ui";
import {meetingMinutesEpic} from "./meetingMinutes";

export const INDIVIDUAL_ID_FETCH_SIZE = 40;
export const INDIVIDUAL_ID_BUFFER_MS = 100;
export const INDIVIDUAL_ID_DEDUP_LOOKBACK_INTERVAL_MS = 100;
export const MODEL_INSERTION_BUFFER_INTERVAL_MS = 300;



export const catchErrorsandResume = number => catchError((error,source) => concat(of(networkError({...error, number: `10087-${number}-${error.status}`})),source));
export const requestDedupInterval$ = interval(INDIVIDUAL_ID_DEDUP_LOOKBACK_INTERVAL_MS);

export const rootEpic = (action$, store) => combineEpics(
  codesEpic,
  bidsEpic,
  projectsEpic,
  usersEpic,
  companiesEpic,
  rfisEpic,
  submittalsEpic,
  tasksEpic,
  dailyLogsEpic,
  meetingMinutesEpic,
  punchListEpic,
  bidContactsEpic,
  projectContactsEpic,
  filesEpic,
  reportsEpic,
)(action$, store);



// WEBPACK FOOTER //
// ./src/network/index.js